<div class="container">
  <div *ngIf="isLoading" class="row justify-content-center">
    <fa-icon style="width: 50px; height: 50px" class="fa-5x fa-spin" [rotate]="rotate" [icon]="faSpinner"></fa-icon>
  </div>
  <!-- <div [ngStyle]="{ 'margin-top': marginTop + 'px' }"></div> -->
</div>
